import React from "react";
import {
  iconLinkBtnbaseStyles,
  iconLinkBtnarrowStyles,
  iconLinkBtndisabledStyles,
  iconLinkBtnenabledStyles,
  iconLinkBtnsizeStyles,
} from ".././utils/css/baseStyles";
import { IconButtonLinkProps } from "./ComponentProps";
import { useTranslation } from "react-i18next";
const IconButtonLink: React.FC<IconButtonLinkProps> = ({
  size,
  text,
  onClick,
  isDisabled,
  icon,
  styles,
}) => {
  const containerClasses = `${iconLinkBtnbaseStyles} ${
    iconLinkBtnsizeStyles[size]
  } ${isDisabled ? iconLinkBtndisabledStyles : iconLinkBtnenabledStyles}`;
  const { t, i18n } = useTranslation();
  return (
    <button
      className={containerClasses}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      style={styles || undefined}
    >
      <div className="flex justify-center items-center">
        <div className="mr-4">
          {icon}
          {/* <AiFillFilePdf size={size == "small" ? "20px" : "40px"} /> */}
        </div>

        <span className="flex-grow text-left font-bold text-sm">{t(text)}</span>

        <span className={iconLinkBtnarrowStyles}>&#x276F;</span>
      </div>
    </button>
  );
};

IconButtonLink.defaultProps = {
  size: "medium",
  text: "Lorem Ipsum Dolor Sit Amet",
  onClick: () => {},
  isDisabled: false,
  icon: null,
};

export default IconButtonLink;
